// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./assets/Inter-Light.ttf");
var ___CSS_LOADER_URL_IMPORT_1___ = require("./assets/soleil-regular.woff2");
var ___CSS_LOADER_URL_IMPORT_2___ = require("./assets/soleil-regular.woff");
var ___CSS_LOADER_URL_IMPORT_3___ = require("./assets/soleil-regular.ttf");
var ___CSS_LOADER_URL_IMPORT_4___ = require("./assets/Gilroy-Light.ttf");
var ___CSS_LOADER_URL_IMPORT_5___ = require("./assets/Gilroy-Light.woff");
var ___CSS_LOADER_URL_IMPORT_6___ = require("./assets/Gilroy-Light.woff2");
var ___CSS_LOADER_URL_IMPORT_7___ = require("./assets/Gilroy-ExtraBold.ttf");
var ___CSS_LOADER_URL_IMPORT_8___ = require("./assets/soleil-bold.woff2");
var ___CSS_LOADER_URL_IMPORT_9___ = require("./assets/soleil-bold.woff");
var ___CSS_LOADER_URL_IMPORT_10___ = require("./assets/soleil-bold.ttf");
var ___CSS_LOADER_URL_IMPORT_11___ = require("./assets/soleil-book.woff2");
var ___CSS_LOADER_URL_IMPORT_12___ = require("./assets/soleil-book.woff");
var ___CSS_LOADER_URL_IMPORT_13___ = require("./assets/soleil-book.ttf");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
exports.push([module.id, "#_28OGmH2_6lDDtKVZltGVKD{color:#06a86e}#_1iEYOO-dbGQM2a8puuYUUU{color:#e11}@font-face{font-family:\"inter\";font-style:normal;font-weight:normal;src:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ")}@font-face{font-family:\"soleil-regular\";font-style:normal;font-weight:normal;src:url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + "),url(" + ___CSS_LOADER_URL_REPLACEMENT_2___ + "),url(" + ___CSS_LOADER_URL_REPLACEMENT_3___ + ")}@font-face{font-family:\"gilroy-light\";font-style:normal;font-weight:normal;src:url(" + ___CSS_LOADER_URL_REPLACEMENT_4___ + "),url(" + ___CSS_LOADER_URL_REPLACEMENT_5___ + "),url(" + ___CSS_LOADER_URL_REPLACEMENT_6___ + ")}@font-face{font-family:\"gilroy-extra-bold\";font-style:normal;font-weight:normal;src:url(" + ___CSS_LOADER_URL_REPLACEMENT_7___ + ")}@font-face{font-family:\"soleil-bold\";font-style:normal;font-weight:normal;src:url(" + ___CSS_LOADER_URL_REPLACEMENT_8___ + "),url(" + ___CSS_LOADER_URL_REPLACEMENT_9___ + "),url(" + ___CSS_LOADER_URL_REPLACEMENT_10___ + ")}@font-face{font-family:\"soleil-book\";font-style:normal;font-weight:normal;src:url(" + ___CSS_LOADER_URL_REPLACEMENT_11___ + "),url(" + ___CSS_LOADER_URL_REPLACEMENT_12___ + "),url(" + ___CSS_LOADER_URL_REPLACEMENT_13___ + ")}._29RSbXLei-I7KOaUy5SGqO{font-family:\"Poppins\",sans-serif}[white-label=false]{--mainGradient-colour: linear-gradient(101.48deg, #df193d -6.99%, #82192c 108.46%);--mainColourText-colour: #df193d;--scrollBar-colour: linear-gradient(101.48deg, #df193d -6.99%, #82192c 108.46%)}[white-label=true]{--mainGradient-colour: linear-gradient(179.92deg, #3A53A7 0.07%, #69CDED 152.62%);--mainColourText-colour: #3A53A7;--scrollBar-colour: linear-gradient(179.92deg, #3A53A7 0.07%, #69CDED 152.62%)}canvas{position:relative !important}body{width:100%;margin:0}@media screen and (min-width: 600px){::-webkit-scrollbar-thumb{background:var(--scrollBar-colour);border-radius:10px}::-webkit-scrollbar-thumb:hover{background:var(--scrollBar-colour)}}._3-TKiPtlER7s-e0juoBRFA{margin-top:-1px;flex-grow:1;background:#000;position:relative}html,body,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,embed,figure,figcaption,footer,header,hgroup,menu,nav,output,ruby,section,summary,time,mark,audio,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}", ""]);
// Exports
exports.locals = {
	"gradientYellow": "linear-gradient(to right, #B3FF20 0%, #D3FE12 37.84%, #EFFD06 77.06%, #F9FD02 100%)",
	"alphaRed": "rgba(255,73,73,.28)",
	"aqua": "#00afd0",
	"brightYellow": "#ffff09",
	"backgroundBlack": "#000",
	"darkGrey": "#1a1723",
	"darkGrey2": "#1f2024",
	"darkerGrey": "#14101e",
	"darkerGreyAlpha": "rgba(20,16,30,.85)",
	"green": "#06a86e",
	"greenDark": "#105e44",
	"greenMain": "#00b377",
	"lightGrey": "gray",
	"lightGrey2": "#454545",
	"lightGrey4": "#404040",
	"offBlack": "#0c0c0e",
	"purple": "#5922fe",
	"redMain": "#f34603",
	"white": "#fff",
	"sellRed": "#f34603",
	"buyGreen": "#13946e",
	"firstColor": "#d3fe12",
	"secondColor": "#effd06",
	"thirdColor": "#f9fd02",
	"statusColourOne": "#b3ff20",
	"statusColourTwo": "#d3fe12",
	"statusColourThree": "#effd06",
	"statusColourFour": "#f9fd02",
	"barWebColor": "#f9fd02",
	"barMobileColor": "#f9fd02",
	"offBackColor": "#eef1f9",
	"onBackColor": "#2952ac",
	"onHandleColor": "#fff",
	"backIconColourOne": "#b3ff20",
	"backIconColourTwo": "#d3fe12",
	"backIconColourThree": "#effd06",
	"backIconColourFour": "#f9fd02",
	"backIconFilledColourOne": "#b3ff20",
	"backIconFilledColourTwo": "#d3fe12",
	"backIconFilledColourThree": "#effd06",
	"backIconFilledColourFour": "#f9fd02",
	"backIconFilledColour": "#000",
	"mobBackIcon": "#fff",
	"levelBarWeb": "#006dfe",
	"levelBarMobile": "#006dfe",
	"logoColourOne": "#b3ff20",
	"logoColourTwo": "#d3fe12",
	"logoColourThree": "#effd06",
	"logoColourFour": "#f9fd02",
	"footerLogo": "gray",
	"donutColourOne": "#b3ff20",
	"donutColourTwo": "#d3fe12",
	"donutColourThree": "#effd06",
	"donutColourFour": "#f9fd02",
	"AssetTransitionUp": "#fff",
	"AssetTransitionDown": "#d45036",
	"AssetPriceUp": "#7bc37e",
	"AssetPriceDown": "#9c0505",
	"openTradesProfit": "green",
	"openTradesLoss": "red",
	"levelsParametersProfit": "#d3fe12",
	"levelsParametersLoss": "#ed5504",
	"tableTextColour": "rgba(255,255,255,.5)",
	"logoTextColour": "#fcfcfc",
	"adminLogoutIconColour": "#fff",
	"gradientWhiteLabelToptier": "linear-gradient(179.92deg, #3A53A7 0.07%, #69CDED 152.62%)",
	"gradientWhiteLabelRocket": "linear-gradient(101.48deg, #df193d -6.99%, #82192c 108.46%)",
	"whiteLabelToptier": "#3a53a7",
	"whiteLabelRocket": "#df193d",
	"profit-trade": "_28OGmH2_6lDDtKVZltGVKD",
	"loss-trade": "_1iEYOO-dbGQM2a8puuYUUU",
	"fPoppins": "_29RSbXLei-I7KOaUy5SGqO",
	"mainPage": "_3-TKiPtlER7s-e0juoBRFA"
};
module.exports = exports;
